(function() {
  'use strict';

  angular.module('app.pages.dashboard')
    .controller('ReportsCtrl', ReportsCtrl);

  /** @ngInject */
  function ReportsCtrl($state, Reports, maps, reportdata, fields, $window, esriLoader, appConfig) {
    let vm = this;
    // letter type to generate
    vm.letterTypeToGenerate;

    vm.exporting = false;

    // set the field list in the map report factory
    reportdata.setFields(fields);

    // get auction dates for UI
    getAuctionDates();

    // Parcels.getFutureAuctionDates(false).then(function(allAuctionDates) {
    //   vm.auctionDates = allAuctionDates;
    // });

    // // exporting letters busy
    // vm.exporting = false;

    // default dropdown headers
    vm.reportTitle = 'Choose a report';
    // vm.dateTitle = 'Choose a date range';
    vm.formatTitle = 'Choose a file format';
    // vm.letterTitle = 'Choose a letter type';
    //  vm.startDate = 'Choose start date';
    vm.auctionYear = 'Choose year';
    vm.auctionDate = 'Choose date';

    vm.dateFormat = 'MM/dd/yyyy';

    // default price drop down title
    vm.priceTitle = 'Price';
    vm.priceMin = '';
    vm.priceMax = '';
    // vm.year = new Date().getFullYear();
    vm.year = 'Choose year';

    // Checkbox for option of using a date range
    vm.dateRange = false;

    vm.auctionYears = [];
    vm.auctionDates = [];
    vm.displayDates = [];
    vm.changeYears = [];
    getChangeYears();

    vm.defaultReports = [
      'Pre-auction summary',
      'Post-auction summary',
      'Unsold parcels currently available for sale'
    ];

    // Use this array sto define the different reports available and the fields they will need.
    vm.types = [
      //   {
      //   name: 'Choose a report',
      //   id: 'select-report',
      //   description: '',
      //   fields: {
      //     date: false,
      //     acres: false,
      //     price: false,
      //     riparian: false,
      //     filetype: false
      //   }
      // },
      {
        name: 'Pre-Auction Land Sale Summary',
        id: 'pre-auction',
        description: '',
        layer: '',
        query: '',
        fields: {
          date: true,
          filetype: true
        }
      }, {
        name: 'Post-Auction Summary',
        id: 'post-auction',
        description: '',
        layer: '',
        query: '',
        fields: {
          date: true,
          filetype: true
        }
      }, {
        name: 'Unsold parcels currently available for sale',
        id: 'unsold-parcels',
        description: '',
        layer: 'Parcels',
        query: 'Sold_type IS NULL AND Board_Class_Action = \'Non-Conservation\' AND TaxForfeitedStatus = \'Active\' AND Total_parcel_price IS NOT NULL AND ProposedSaleType = \'Over the Counter\'',
        fields: {
          date: false,
          filetype: true
        }
      }, {
        name: 'Forfeiture Classification Recommendations',
        id: 'class-recs',
        description: '',
        layer: 'Parcels',
        query: 'Forfeiture_date = [selected date]',
        fields: {
          startDate: true,
          endDate: true,
          filetype: true,
          // forfeitStatus: true
        }
      }, {
        name: 'Revalue Summary',
        id: 'revalue',
        description: '',
        layer: 'Parcels',
        query: 'Sold_type IS NULL AND Board_Class_Action = \'Non-Conservation\' AND TaxForfeitedStatus = \'Active\' AND Total_parcel_price IS NOT NULL\n (Then find parcels where land price or special assessment balance increased or decreased since Last_LS_date)',
        fields: {
          dateRange: true,
          startDate: true,
          endDate: true,
          filetype: true,
          query: true
        }
      }, {
        name: 'Final Sale Board List',
        id: 'final-sale-list',
        description: '',
        layer: 'Tracts',
        query: '(CityTwpResponse = \'Approve\' OR CityTwpResponse = \'Approve by No Response\') AND DNRResponse = \'Approve\' AND ProposedSaleType = \'Auction\'',
        fields: {
          date: false,
          filetype: true
        }
      }, {
        name: 'Forfeit Land Value Change',
        id: 'forfeit-value-change',
        description: 'List of properties whose value has changed from the previous year.',
        layer: 'Parcels',
        query: null,
        fields: {
          date: false,
          filetype: true
        }
      }
    ];

    vm.params = {
      date: new Date(),
      startDate: new Date(),
      endDate: new Date(),
      filetype: '',
      query: ''
    };

    vm.forfeitureTitle = 'Forfeiture Date';

    vm.today = function() {
      vm.startDate = new Date();
      vm.endDate = new Date();
    };
    vm.today();

    vm.forfsdate = {
      opened: false
    };
    vm.forfedate = {
      opened: false
    };


    vm.clear = function() {
      vm.startDate = null;
      vm.endDate = null;
    };
    vm.openCalS = function() {
      vm.forfsdate.opened = true;
    };
    vm.openCalE = function() {
      vm.forfedate.opened = true;
    };

    vm.dateOptions = {
      //    dateDisabled: disabled,
      formatYear: 'yyyy',
      maxDate: new Date(),
      startingDay: 1
    };


    // vm.letterTypes = [{
    //     name: 'DNR Future Sales Letter',
    //     value: 'dnrfutureletter',
    //     layer: 'Parcels',
    //     query: 'ProposedSaleType IS NULL AND TaxForfeitedStatus = \'Active\' AND Board_Class_Action IS NULL'
    //   },
    //   {
    //     name: 'DNR Land Sale List Letter',
    //     value: 'dnrlandsalelist',
    //     layer: 'Tracts',
    //     query: 'ProposedSaleType = \'Auction\' AND Last_LS_date > \'1/1/CurrentYear\' AND Last_LS_date < \'12/31/CurrentYear\''
    //   },
    //   {
    //     name: 'Adjacent Land Owner Letter of Interest',
    //     value: 'adjacentletter',
    //     layer: 'Tracts',
    //     query: 'Last_LS_date > \'Current Date\''
    //   } , {
    //     name: 'Classification Letter to City',
    //     value: 'classLetter',
    //     layer: 'Parcels',
    //     query: 'ProposedSaleType IS NULL AND TaxForfeitedStatus = \'Active\' AND Board_Class_Action IS NULL AND Office_Classification = \'Non-Conservation\' AND Political_Sub LIKE \'CITY%\''
    //   }
    // ];

    vm.fileTypes = [
      //      'CSV',
      'Excel',
      'PDF'
    ];

    vm.popupStartDate = {
      opened: false
    };

    vm.popupEndDate = {
      opened: false
    };


    vm.openStart = function() {
      vm.popupStartDate.opened = true;
    };

    vm.openEnd = function() {
      vm.popupEndDate.opened = true;
    };

    vm.reportType = function(reporttype) {
      if (reporttype !== null) {
        vm.reportTitle = reporttype.name;
        vm.type = reporttype;
        vm.reportToGenerate = _.find(vm.types, {
          'id': vm.type.id
        });
      } else {
        vm.reportTitle = 'Choose a report';
      }
    };

    vm.fileFormat = function(filetype) {
      if (filetype !== null) {
        vm.formatTitle = 'Export as ' + filetype;
        vm.params.filetype = filetype;
      } else {
        vm.formatTitle = 'Choose a file format';
      }
    };

    // vm.letterFormat = function(lettertype) {
    //   vm.letterTypeToGenerate = _.find(vm.letterTypes, {'name': lettertype});
    //   if (lettertype !== null ) {
    //     vm.letterTitle = lettertype;
    //     // vm.params.filetype = lettertype;
    //   } else {
    //     vm.letterTitle = 'Choose a letter type';
    //   }
    // };

    vm.loadAuctionDates = function(year) {
      vm.displayDates = [];
      for (let date in vm.auctionDates) {
        if (vm.auctionDates[date].getFullYear() === year) {
          let theDate = _formatDate(vm.auctionDates[date]);
          if (vm.displayDates.indexOf(theDate) < 0) {
            vm.displayDates.push(theDate);
          }
        }
      }
      vm.displayDates.sort();
      // console.log(vm.displayDates);
      vm.auctionYear = year;
      vm.auctionDate = 'Choose date';
    };

    vm.setChangeYear = function(year) {
      vm.year = year;
    }

    vm.setDate = function(date) {
      vm.auctionDate = date;
      vm.params.date = date;
    };

    // prices to display in the drop down list
    vm.minPrices = [
      0,
      2800,
      10000,
      20000,
      50000,
      150000,
      450000
    ];

    vm.maxPrices = [
      2800,
      10000,
      20000,
      50000,
      150000,
      450000
    ];

    vm.minPriceOpen = true;
    vm.maxPriceOpen = false;

    vm.setMinPrice = function(price) {
      vm.priceMin = price;
      vm.priceMax = '';
      vm.minPriceOpen = false;
      vm.maxPriceOpen = true;
      // filter the max price list to remove options less than the mix price
      vm.maxPrices = vm.maxPrices.filter(_greaterThan(price));
      // set the drop down title
      _setPriceDropdownTitle();
    };

    vm.setMaxPrice = function($event, price) {
      vm.priceMax = price;
      // close the dropdown list
      $event.preventDefault();
      $event.stopPropagation();
      vm.minPriceOpen = true;
      vm.maxPriceOpen = false;
      // set the drop down title
      _setPriceDropdownTitle();
    };

    vm.setMinPriceKey = function() {
      _setPriceDropdownTitle();
      // filter the max price list to remove options less than the mix price
      vm.maxPrices = vm.maxPrices.filter(_greaterThan(vm.priceMin));
    };

    vm.setMaxPriceKey = function() {
      _setPriceDropdownTitle();
    };

    vm.changeList = function(type) {
      if (type === 'min') {
        vm.minPriceOpen = true;
        vm.maxPriceOpen = false;
      } else {
        vm.minPriceOpen = false;
        vm.maxPriceOpen = true;
      }
    };

    vm.filterByPrice = function() {
      vm.status = !vm.status;
      let query = {
        'price': ''
      };
      if (vm.priceMax === '' && vm.priceMin !== '') {
        query.price = 'Total_parcel_price > ' + vm.priceMin;
      } else if (vm.priceMax !== '' && vm.priceMin === '') {
        query.price = 'Total_parcel_price < ' + vm.priceMax;
      } else if (vm.priceMin === '' && vm.priceMax === '') {
        _setPriceDropdownTitle();
        query.price = '';
      } else {
        query.price = 'Total_parcel_price > ' + vm.priceMin + ' AND Total_parcel_price < ' + vm.priceMax;
      }
      // console.log(query);
      // maps.filterProperties(query);
      // Parcels.list();
    };

    vm.clearPrices = function() {
      vm.priceMin = '';
      vm.priceMax = '';
      vm.priceTitle = 'Price';
      // maps.filterProperties({'price': ''});
    };


    vm.clearSelections = function() {
      vm.exporting = false;
      vm.reportTitle = 'Choose a report';
      vm.dateTitle = 'Choose a date range';
      vm.formatTitle = 'Choose a file format';
    };

    vm.submit = function() {
      vm.exporting = true;
      if (vm.reportTitle === 'Choose a report') {
        vm.exporting = false;
        alert('Please select a report type!');
      } else if (vm.type.id === 'pre-auction') {
        let params = _processParams();
        let mapPolyLayer = maps.getFilterLayer();

        reportdata.getPreAuctionData(params, mapPolyLayer).then(function(reportData) {
          // console.log('Heres the report data ', reportData);
          if (reportData.length === 0) {
            vm.exporting = false;
            alert('No tracts found for the selected year and auction date.');
          } else {
            params.reportData = reportData;
            // if (dataValid) {
            Reports.preAuction(params).then(function(results) {
              // console.log('results: ', results);
              vm.exporting = false;
              if (results) {
                window.open(window.location.origin + results);
              } else {                
                alert('There is no result found with the current filters!');
                vm.exporting = false;
              }
            });
          }
        });

        // let dataValid = true;

        // for (let key in params) {
        //   if (key === 'phase') {
        //     if (params.phase.length === 0 ){
        //       alert('Please select an application phase!');
        //       dataValid = false;
        //     }
        //   } else {
        //     if (params[key] === undefined) {
        //       alert('Please select a correct date format!');
        //       dataValid = false;
        //     }
        //   }
        // }
      } //end pre-auction summary
      else if (vm.type.id === 'post-auction') {
        let params = _processParams();
        // params.date = _formatDate(params.date);
        let mapPolyLayer = maps.getFilterLayer();
        if (params.filetype !== 'PDF') {
          reportdata.getPostAuctionData(params, mapPolyLayer)
            .then(function(results) {
              console.log('Heres the report data ', results);
              if (typeof results === 'object') {
                params.reportData = results;
                params.filetype = 'Excel';
                Reports.postAuction(params).then(function(results) {
                  vm.exporting = false;
                  console.log('results', results);
                  if (results) {
                    window.open(window.location.origin + results);
                  } else {
                    alert('There is no result found with the current filters!');
                  }
                });
              } else {
                vm.exporting = false;
                alert('No historical data available for the date selected');
              }
            });
        } else {
          vm.exporting = false;
          alert('PDF option is not available for this report yet!');
        }

        // let dataValid = true;

        // for (let key in params) {
        //   if (key === 'phase') {
        //     if (params.phase.length === 0 ){
        //       alert('Please select an application phase!');
        //       dataValid = false;
        //     }
        //   } else {
        //     if (params[key] === undefined) {
        //       alert('Please select a correct date format!');
        //       dataValid = false;
        //     }
        //   }
        // }
      } //end post-auction summary
      else if (vm.type.id === 'unsold-parcels') {
        let params = _processParams();
        // params.date = _formatDate(params.date);
        let mapPolyLayer = maps.getFilterLayer();
        reportdata.getUnsoldParcelsData(params, mapPolyLayer)
          .then(function(reportData) {
            // console.log('Heres the report data ', reportData);
            params.reportData = reportData;
            Reports.unsold(params).then(function(results) {
              // console.log('results', results);
              vm.exporting = false;
              if (results) {
                window.open(window.location.origin + results);
              } else {
                alert('There is no result found with the current filters!');
              }
            });
          });

      } //end unsold parcels
      else if (vm.type.id === 'class-recs') {
        if (vm.params.filetype === '') {
          alert('Please choose a file type.');
        } else {
          //  console.log(vm.forfeitDate);
          vm.params.startDate = _formatDate(vm.startDate);
          vm.params.endDate = _formatDate(vm.endDate);
          let params = _processParams();
          reportdata.getClassRecsData(params).then(function(reportData) {
            if (reportData.length > 0) {
              params.reportData = reportData;
              Reports.classRec(params).then(function(results) {
                //console.log('results: ', results);
                vm.exporting = false;
                if (results) {
                  window.open(window.location.origin + results);
                } else {
                  alert('There is no result found with the current filters!');
                  vm.exporting = false;
                }
              });
            } else {
              alert('There is no result found with the current filters!');
              vm.exporting = false;
            }

          });
        }
      } else if (vm.type.id === 'revalue') {
        vm.params.dateRange = vm.dateRange;
        let revalQuery = 'TaxForfeitedStatus = \'Active\' AND Board_Class_Action = \'Non-Conservation\' AND Sold_type IS NULL AND Total_parcel_price IS NOT NULL';
        
        // If a date range is used, add the additional date query
        if (vm.dateRange) {
          vm.params.startDate = _formatDate(vm.startDate);
          vm.params.endDate = _formatDate(vm.endDate);
          let dateQuery = ' AND (LandPriceIncrease between \'' + vm.params.startDate + '\' AND \'' + vm.params.endDate + '\' OR ReducedLandPrice between \'' + vm.params.startDate + '\' AND \'' + vm.params.endDate + '\' OR SpecAssessIncrease between \'' + vm.params.startDate + '\' AND \'' + vm.params.endDate + '\' OR SpecAssessDecrease between \'' + vm.params.startDate + '\' AND \'' + vm.params.endDate + '\')';
          revalQuery = revalQuery + dateQuery;
        }
        
        vm.params.query = revalQuery;
        let params = _processParams();
        // console.log('params: ', params); 

        reportdata.getRevalueData(params).then(function(reportData) {
          console.log('Heres the report data ', reportData);
          params.reportData = reportData;

          // if (dataValid) {
          Reports.revalue(params).then(function(results) {
            vm.exporting = false;
            console.log('results', results);
            if (results) {
              window.open(window.location.origin + results);
            } else {
              alert('There is no result found with the current filters!');
            }
          });
        });

      } else if (vm.type.id === 'final-sale-list') {
        let params = _processParams();
        // console.log('params: ', params);
        reportdata.getFinalSaleData().then(function(reportData) {
          params.reportData = reportData;
          // console.log('final sale list ', params.reportData);
          if (params.reportData.length > 0) {
            Reports.finalSaleList(params).then(function(results) {
              vm.exporting = false;
              // console.log('results', results);
              if (results) {
                window.open(window.location.origin + results);
              } else {
                alert('There is no result found with the current filters!');
              }
            });
          } else {
            vm.exporting = false;
            alert('No features found for this report!');
          }
        });

      } else if (vm.type.id === 'forfeit-value-change') {
        let params = _processParams();
        console.log('vm.year: ', vm.year);
        reportdata.getForfeitValueChange(vm.year).then(function(reportData) {
          params.reportData = reportData;
          params.filetype = 'Excel';
          params.year = vm.year;
          if (params.reportData.length > 0) {
            Reports.forfeitValueChange(params).then(function(results) {
              vm.exporting = false;
              if (results) {
                window.open(window.location.origin + results);
              } else {
                alert('There is no result found with the current filters!');
              }
            });
          } else {
            vm.exporting = false;
            alert('No features found for this report!');
          }
        });
      }
    };

    // PRIVATE FUNCTIONS ********************************************************************************

    //  Runs through the available fields for the selected report type and adds a param if it is defined.
    function _processParams() {
      let params = {},
        fields = vm.type.fields;
      for (let field in fields) {
        if (fields.hasOwnProperty(field)) {
          if (fields[field]) {
            // console.log('field, vm.params[field]: ', field, vm.params[field]);
            params[field] = vm.params[field];
          }
        }
      }
      return params;
    }

    function _setPriceDropdownTitle() {
      if (vm.priceMax === '' && vm.priceMin !== '') {
        vm.priceTitle = '$' + _numberWithCommas(vm.priceMin) + '+';
      } else if (vm.priceMax !== '' && vm.priceMin === '') {
        vm.priceTitle = ' - $' + _numberWithCommas(vm.priceMax);
      } else if (vm.priceMax === '' && vm.priceMin === '') {
        vm.priceTitle = 'Price';
      } else {
        vm.priceTitle = '$' + _numberWithCommas(vm.priceMin) + ' - $' + _numberWithCommas(vm.priceMax);
      }
    }

    function _numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function _greaterThan(value) {
      return function(element) {
        return (element >= value);
      };
    }

    function _formatDate(date) {
      return (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
    }

    function _formatEsriDate(date) {
      let newDate = new Date(date);
      date = new Date(newDate.getTime() + newDate.getTimezoneOffset() * 60000);
      return date;
    }

    function getAuctionDates() {
      esriLoader.require([
        'esri/tasks/query',
        'esri/tasks/QueryTask'
      ], function(
        Query,
        QueryTask
      ) {
        // find distinct auction dates
        let query = new Query();
        query.returnGeometry = false;
        query.outFields = ['Last_LS_date'];
        query.returnDistinctValues = true;
        query.where = 'Last_LS_date IS NOT null';
        let queryTask = new QueryTask(appConfig.getConfig().tractsUrl);
        queryTask.execute(query, function(results) {
          let features = results.features;
          for (let feature in features) {
            let auctionDate = _formatEsriDate(features[feature].attributes.Last_LS_date); // jshint ignore:line
            if (vm.auctionYears.indexOf(auctionDate.getFullYear()) < 0) {
              vm.auctionYears.push(auctionDate.getFullYear());
            }
            vm.auctionDates.push(auctionDate);
          }
          vm.auctionYears.sort(function(a, b) {
            return b - a;
          });
        }, function(error) {
          console.error('Query error: ', error);
        });

      });
    }

    function getChangeYears() {
      const thisYear = new Date().getFullYear();
      const firstYear = thisYear - 5;
      for (let y = firstYear; y <= thisYear; y++) {
        vm.changeYears.push(y);
      }
    }



    // function _formatDate(date) {
    //   return (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
    // }
  }
})();
